'use es6';

import { Record } from 'immutable';
export default Record({
  high: undefined,
  low: undefined
});